import {useMutation, UseMutationResult} from "@tanstack/react-query";
import {api} from "@/features/api";

const usePostReactivateUser: () => UseMutationResult = () =>
  useMutation({
    // retry is set to 3 to allow for transient errors
    // such as network issues or server overload
    // to be retried before failing
    retry: 3,

    mutationFn: async () => {
      const response =
        await api("TRENDARO_API_URL").post(`/users/me/reactivate`);

      if (response.status === 401)
        throw new Error("Neoprávněný přístup k Trendaro API.");

      if (!response.ok) {
        throw new Error(
          `HTTP ${response.status} při reaktivaci uživatelského účtu.`,
        );
      }

      return true;
    },
  });

export default usePostReactivateUser;
